document.addEventListener("DOMContentLoaded", function() {
    const listaMenu = document.querySelectorAll('.rotuloNoticias')
    const listaConteudo = document.querySelectorAll('#listaNoticias li')

    var cont = 0;

    if(listaMenu && listaConteudo){
        const ativaLink = (item) => {
            mostraItens(item.dataset.item)
            let elemendoDoMeio = document.querySelectorAll("#listaNoticias li.ativo .DestaqueNoticias-lista-item-img img")[1]
            elemendoDoMeio.style.height = "310px"
            elemendoDoMeio.style.width = "100%"
            elemendoDoMeio.style.objectFit = "cover"
        }
        
        listaMenu.forEach((item) =>{
            listaMenu[0].classList.add('ativo')
            item.addEventListener("click", (event) => {
                listaMenu.forEach(removeClasse => {
                    removeClasse.classList.remove('ativo')
                })
                item.classList.add("ativo")
            })
        })
        
        const mostraItens = (rotulo) => {
            listaConteudo.forEach(link => link.classList.remove('ativo'))
            cont = 0;
            listaConteudo.forEach(item => {
                if (item.dataset.item === rotulo && cont < 3) {
                    item.classList.add('ativo')
                    cont ++
                }
            })
        }
        listaMenu.forEach((link, index) => {
            link.addEventListener('click', () => {
                ativaLink(link)
            })
        })
        
        listaConteudo.forEach(link => link.classList.remove('ativo'))
        
        listaConteudo.forEach(item => {
            if (item.dataset.item === 'Geral' && cont < 3) {
                item.classList.add('ativo')
                cont ++
            }
        })
    }



    const activeItems = document.querySelectorAll("#listaNoticias li.ativo .DestaqueNoticias-lista-item-img img");
    
    if (activeItems.length > 1) {
        let elementoDoMeio = activeItems[1];
        
        elementoDoMeio.style.height = "310px";
        elementoDoMeio.style.width = "100%";
        elementoDoMeio.style.objectFit = "cover";
    }
});